import React from 'react';
import {List} from 'immutable';
import classnames from 'classnames';
import CONSTANTS from 'client/constants';
import {callAction} from 'client/framework';
import {history} from 'client/history';
import sessionStore from 'client/Session/SessionStore';
import Subheader, {SubheaderLinks} from 'generic/Subheader/Subheader.react';

import SubheaderDropDown from 'generic/Subheader/SubheaderDropDown.react';
import ErrorPage from 'client/static/Error/ErrorPage.react';
import schoolAdministrationStore from './SchoolAdministrationStore';
import schoolAdministrationActions from './SchoolAdministrationActions';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import schoolLinks from './School/schoolLinks';

import './school-administration.scss';

const handleSubheaderSchoolSelect = (option) => {
  if (option === 'All Schools') {
    callAction(schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID, null);
    history.pushState(null, '/school-admin');
  } else {
    const selected = schoolAdministrationStore.getMenuItems().find((school) => {
      return school.getName() === option;
    });
    callAction(schoolAdministrationActions.SET_ACTIVE_SCHOOL_ID, selected.getId());
    history.pushState(null, `/school-admin/${selected.getId()}/dashboard`);
  }
};

export default class SchoolAdministration extends React.Component {
  UNSAFE_componentWillMount() {
    callAction(schoolAdministrationActions.SET_ACTIVE_USER_ID, sessionStore.getUserId());
  }

  componentDidUpdate() {
    if (!schoolAdministrationStore.getMenuItems()) {
      const schools = schoolAdministrationStore.getAllSchools();
      callAction(
        schoolAdministrationActions.INITIALIZE_MENU_ITEMS,
        List.isList(schools) ? schools : null
      );
    }
  }

  generateSubheader() {
    let options = new List();

    if (schoolAdministrationStore.getMenuItems()) {
      options = schoolAdministrationStore
        .getMenuItems()
        .map((school) => {
          return school.getName();
        })
        .toList();
    }

    options = options.unshift('All Schools');

    let selectedOption = 'All Schools';
    let subheaderLinks = null;
    if (schoolAdministrationStore.hasActiveSchool()) {
      selectedOption = schoolAdministrationStore.getActiveSchool().get('name');
      const currentPath = process.env.IS_BROWSER ? window.location.pathname : '';
      const activePath = currentPath.replace(/\/(manage-staff|usage-reports).*$/, '/$1');
      subheaderLinks = (
        <SubheaderLinks
          links={schoolLinks}
          subpath={`/school-admin/${this.props.params.schoolId}`}
          activePath={activePath}
        />
      );
    }

    const schoolSelector = (
      <div className='school-administration-subheader__links'>
        <SubheaderDropDown
          selectedOption={selectedOption}
          options={options}
          selectOptionCallback={handleSubheaderSchoolSelect}
        />
        {subheaderLinks}
      </div>
    );

    return <Subheader className='school-administration-subheader' leftContent={schoolSelector} />;
  }

  render() {
    if (
      sessionStore.hasValidSession() === false ||
      (sessionStore.isSchoolAdministrator() === false && sessionStore.isSuper() === false)
    ) {
      return <ErrorPage errorCode={CONSTANTS.ERROR_TYPES.UNAUTHORIZED} />;
    }

    /**
     * If the user is an administrator of the platform... don't show the loading
     * indicator... they are going to use SchoolSearch to find their school.
     */
    if (!sessionStore.isSuper() && !schoolAdministrationStore.isSchoolDataReady()) {
      return <LoadingIndicator />;
    }

    const isCreateAccountsRoute =
      this.props.routes[this.props.routes.length - 1].path === 'create-accounts';

    return (
      <div>
        {this.generateSubheader()}
        <div className='school-administration'>
          {this.props.children && React.cloneElement(this.props.children, {})}
        </div>
      </div>
    );
  }
}
